export const commentItemStyles = {
  container: { display: 'flex', width: '100%', flexDirection: 'column' },
  avatarContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    height: '40px',
    width: '40px',
    position: 'relative',
  },
  customAvatar: { width: '40px', height: '40px', borderRadius: '8px' },
  defaultAvatarContainer: {
    display: 'flex',
    backgroundColor: '#EDEFF7',
    borderRadius: '8px',
    width: '40px',
    height: '40px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  defaultAvatar: {
    fontFamily: 'Inter',
    color: '#6E707A',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: '146%',
    fontWeight: '500',
    '-webkit-user-select': 'none',
    '-ms-user-select': 'none',
    'user-select': 'none',
  },
  commentContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'flex-start',
    border: '1px solid #F3F4F9',
    borderRadius: '8px',
    padding: '8px 8px 12px 12px',
  },
  commentInfoContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '3px',
  },
  authorNameContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  authorName: {
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '122%',
    color: '#23252F',
  },
  timeSpend: {
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
  },
  authorRole: {
    display: 'flex',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#6E707A',
  },
  commentContent: {
    display: 'flex',
    width: '100%',
    padding: '0',
    fontFamily:
      "'Inter', 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', 'Twemoji', sans-serif",
    '& p, a': {
      fontSize: '14px',
      lineHeight: '146%',
      fontWeight: 400,
      margin: '0',
      color: '#23252F',
      wordBreak: 'break-word',
    },
    '& p': {
      color: '#424550',
    },
    '& span': {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '146%',
      color: '#4D6EF5',
    },
  },
  imagesContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    flexDirection: 'row',
    height: '200px',
  },
  image: {
    maxWidth: '64px',
    maxHeight: '64px',
    objectFit: 'contain',
    borderRadius: '8px',
    cursor: 'pointer',
    border: '1px solid #F3F4F9',
  },
  actionsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  likeReplyContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: '20px',
  },
  actionBtn: {
    padding: '0',
    fontFamily: 'Inter',
    fontStyles: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#23252F',
    textTransform: 'unset',
  },
  postInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '6px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  postInfoBtn: {
    textTransform: 'unset',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    color: '#8C8F9D',
    padding: '0',
    minWidth: 'unset',
  },
  likeInfo: {
    width: '100%',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '148%',
    color: '#FFFFFF',
  },
  hoverUnderline: {
    textDecoration: 'none',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    color: 'inherit',
    margin: 0,
    padding: 0,
    '&:hover': {
      textDecoration: 'underline',
      color: '#23252F',
    },
  },
  withoutUnderline: {
    textDecoration: 'none',
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    color: 'inherit',
    margin: 0,
    padding: 0,
  },
  circularProgress: {
    margin: ' auto',
  },
  greenDot: {
    position: 'absolute',
    display: 'flex',
    width: '10px',
    height: '10px',
    backgroundColor: '#379552',
    border: '2px solid #FFFFFF',
    left: '-4px',
    top: '-4px',
    borderRadius: '50%',
    zIndex: '10',
  },
  iconButton: {
    width: '20px',
    height: '20px',
    padding: 0,
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
};
